export const More = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21 12C21 12.8975 20.2724 13.625 19.375 13.625C18.4775 13.625 17.75 12.8975 17.75 12C17.75 11.1025 18.4775 10.375 19.375 10.375C20.2724 10.375 21 11.1025 21 12ZM6.25 12.0001C6.25 12.8976 5.52246 13.6251 4.625 13.6251C3.72754 13.6251 3 12.8976 3 12.0001C3 11.1026 3.72754 10.3751 4.625 10.3751C5.52246 10.3751 6.25 11.1026 6.25 12.0001ZM12 13.625C12.8975 13.625 13.625 12.8975 13.625 12C13.625 11.1025 12.8975 10.375 12 10.375C11.1026 10.375 10.375 11.1025 10.375 12C10.375 12.8975 11.1026 13.625 12 13.625Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
